import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import axios from "axios";
import queryString from 'qs'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";
import Button from "components/CustomButtons/Button.jsx";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import AcceptInvitation from 'views/Components/AcceptInvitation.jsx'

import dashboardRoutes from "routes/dashboard.jsx";

import appStyle from "assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx";

import image from "assets/img/sidebar-2.jpg";
import cirrusLogo from "assets/img/cirrusLogo.jpg";
import { getApiHeaders } from "../assets/helpers/apiHelper";
import { API_ROOT } from 'api-config';
import { getSearchString } from "../assets/helpers/urlHelper";
import CreditCardProcessorSignup from "../views/Components/CreditCardProcessorSignup"

// Don't define switchRoutes as a constant - it needs to re-render on route changes
// We'll create it inside the render method instead

var ps;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    const searchString = getSearchString(this.props.location.search)
    const values = queryString.parse(searchString)
    var providerId = ''
    if (values.providerId && !isNaN(values.providerId)) {
      providerId = values.providerId
    }
    this.state = {
      mobileOpen: false,
      miniActive: false,
      invitationDialogueOpen: false,
      invitationCode: '',
      showQuickstart: false,
      quickstartVideoUrl: '',
      quickstartVideoText: '',
      providerId: providerId,
      showCreditCardProcessingAccountSetup: false,
      pendingShowCreditCardProcessingAccountSetup: false,
      viewingAsOther: false
    };
    this.resizeFunction = this.resizeFunction.bind(this);
  }
  componentDidMount() {
    if (sessionStorage.getItem("viewingAs")) {
      this.setState({
        viewingAsOther: true
      });
    }
    const params = new URLSearchParams(this.props.location.search);
    //set the invitation code if it is passed
    //don't set otherwise, as we don't want to overwrite a code set on the login page
    if (params.get('invitationCode')) {
      sessionStorage.setItem('invitationCode', params.get('invitationCode'));
    }
    if (sessionStorage.getItem('invitationCode') && sessionStorage.getItem('invitationCode') !== 'null') {
      this.setState({
        invitationDialogueOpen: true,
        invitationCode: sessionStorage.getItem('invitationCode')
      });
    }

    if (params.get('showCreditCardProcessorSignup') && params.get('showCreditCardProcessorSignup') === 'true') {
      this.setState({
        pendingShowCreditCardProcessingAccountSetup: true
      });
    }
    if (params.get('showQuickstart') && params.get('showQuickstart') === 'true') {
      this.getQuickstartVideo()
    } else if (params.get('showCreditCardProcessorSignup') && params.get('showCreditCardProcessorSignup') === 'true') {
      this.linkCreditCardProcessorOpen()
    }

    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.mainPanel, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", this.resizeFunction);
    this.setLogo()
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
    window.removeEventListener("resize", this.resizeFunction);
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute() {
    return this.props.location.pathname !== "/maps/full-screen-maps";
  }
  sidebarMinimize() {
    this.setState({ miniActive: !this.state.miniActive });
  }
  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }

  handleInvitationDialogClose = () => {
    this.setState({ invitationDialogueOpen: false });
    sessionStorage.setItem('invitationCode', '');
  };

  handleQuickstartDialogClose = () => {
    this.setState({ showQuickstart: false });
    if (this.state.pendingShowCreditCardProcessingAccountSetup) {
      this.linkCreditCardProcessorOpen()
    }
  };

  getQuickstartVideo() {
    axios.get(`${API_ROOT}/settings/?selectedSetting=quickstartVideoUrl:quickstartVideoText`, { headers: getApiHeaders() })
      .then(res => this.setQuickstartVideo(res));

  }

  setQuickstartVideo(res) {
    if (res.data && res.data.quickstartVideoUrl) {
      this.setState({
        quickstartVideoUrl: res.data.quickstartVideoUrl,
        quickstartVideoText: res.data.quickstartVideoText,
        showQuickstart: true
      })
    }
  }


  setLogo() {
    var logo = cirrusLogo
    if (sessionStorage.getItem('logoFile') && sessionStorage.getItem('logoFile') !== 'no logo') {
      logo = sessionStorage.getItem('logoFile')
    }
    this.setState({
      logo: logo,
    })
  }

  linkCreditCardProcessorOpen() {
    this.setState({
      showCreditCardProcessingAccountSetup: true
    });
  }

  handleLinkCreditCardProcessorClose() {
    this.setState({
      showCreditCardProcessingAccountSetup: false
    });
  }

  render() {
    const { classes, ...rest } = this.props;

    // Get fresh routes based on current session
    const routes = dashboardRoutes();

    // Debug logging
    console.log('Dashboard render - pathname:', this.props.location.pathname);
    console.log('Dashboard render - routes count:', routes.length);
    console.log('Dashboard render - userGroups:', sessionStorage.getItem('userGroups'));

    // Create switchRoutes inside render with location key to force re-renders
    const switchRoutes = (
      <Switch key={this.props.location.pathname}>
        {routes.map((prop, key) => {
          if (prop.redirect)
            return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
          if (prop.collapse)
            return prop.views.map((prop, key) => {
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            });
          return <Route path={prop.path} component={prop.component} key={key} />;
        })}
      </Switch>
    );

    const mainPanel =
      classes.mainPanel +
      " " +
      cx({
        [classes.mainPanelSidebarMini]: this.state.miniActive,
        [classes.mainPanelWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1
      });
    return (
      <div className={classes.wrapper}>
        <Dialog
          open={this.state.invitationDialogueOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
        >
          <DialogTitle id="form-dialog-title">Accept your invitation</DialogTitle>
          <DialogContent>
            <AcceptInvitation
              invitationCode = {this.state.invitationCode}
              invitationProviderId = 'patient'
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleInvitationDialogClose} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.showQuickstart}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
        >
          <DialogTitle id="form-dialog-title">Cirrus Dental quick start</DialogTitle>
          <DialogContent>
            <p>{this.state.quickstartVideoText}</p>
            <iframe title="quick start" width="760" height="515" src={this.state.quickstartVideoUrl} frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen></iframe>
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleQuickstartDialogClose} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.showCreditCardProcessingAccountSetup}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='sm'
          width='sm'
        >
          <DialogTitle id="form-dialog-title">connect credit card account</DialogTitle>
          <DialogContent>
            <CreditCardProcessorSignup
              providerId = {sessionStorage.getItem('userId')}
            />

          </DialogContent>

          <DialogActions>

            <Button onClick={this.handleLinkCreditCardProcessorClose.bind(this)} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Sidebar
          routes={routes}
          logo={this.state.logo}
          image={image}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color="cirrusBlue"
          bgColor="cirrusBlue"
          miniActive={this.state.miniActive}
          {...rest}
        />
        <div className={mainPanel} ref="mainPanel" style={this.state.viewingAsOther ? { backgroundColor: '#DC143C'} : {}}>
          <Header
            sidebarMinimize={this.sidebarMinimize.bind(this)}
            miniActive={this.state.miniActive}
            routes={routes}
            handleDrawerToggle={this.handleDrawerToggle}
            {...rest}
          />
          {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
          {this.getRoute() ? (
            <div className={classes.content}>
              <div className={classes.container}>{switchRoutes}</div>
            </div>
          ) : (
            <div className={classes.map}>{switchRoutes}</div>
          )}
          {this.getRoute() ? <Footer fluid /> : null}
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withRouter(withStyles(appStyle)(Dashboard));
